import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=004c72d4&scoped=true"
import script from "./FileList.vue?vue&type=script&lang=ts"
export * from "./FileList.vue?vue&type=script&lang=ts"
import style0 from "./FileList.vue?vue&type=style&index=0&id=004c72d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c72d4",
  null
  
)

export default component.exports